import { Card } from "react-bootstrap";

const Description = () => {
  // return (
  //   <Card style={{ width: '19rem', background: '#fff', borderRadius: '9px' }}>
  //     <Card.Body className="cardbody">
  //       <Card.Title className="title">RedCabs vs YellowCabs</Card.Title>
  //       <Card.Subtitle className="sub-title">Trips comparision of two cab<br></br>types in a city.</Card.Subtitle>
  //       <Card.Text style={{marginLeft:'10px', marginBottom : "0px"}}>
  //         NO.OF TRIPS <span style={{marginLeft:'15px'}}>TRIP DURATION</span>
  //       </Card.Text>
  //       <Card.Text style={{marginLeft:'10px', fontWeight: 'bold', marginTop:'5px'}}>
  //         10.0K <span className="" style={{marginLeft:'75px'}}>30 mnts</span>
  //       </Card.Text>
  //     </Card.Body>
  //   </Card>
  // );
  return (
    <Card style={{ width: "19rem", background: "#fff", borderRadius: "9px" }}>
      <Card.Body>
        <Card.Title className="fw-bold">RedCabs vs YellowCabs</Card.Title>
        <Card.Subtitle className="mt-1">
          Trips comparision of two cab<br></br>types in a city.
        </Card.Subtitle>
        <Card.Text className="mt-3">
          <div className="d-flex">
            <p className="me-4">NO.OF TRIPS</p>
            <p>TRIP DURATION</p>
          </div>
          <div className="d-flex fw-bold">
            <p  className="me-7">10.0K</p>
            <p style={{marginLeft:'84px'}}>30 mnts</p>
          </div>
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default Description;
